<template>
    

    <!-- font awsome -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css">
    <!-- App Css-->
    <!-- Costume Css-->
    <div class="layout-wrapper d-lg-flex justify-content-center" data-layout-mode="dark">
    
    <!-- start chat-leftsidebar -->
    <div  id="chat-leftsidebar" class="chat-leftsidebar border-r">
        <div class="tab-content">
            <!-- Start chats tab-pane -->
            <div class="tab-pane show active" id="pills-chat" role="tabpanel" aria-labelledby="pills-chat-tab">
                <!-- Start chats content -->
                <div>
                    <div class="px-4 pt-4">
                        <div class="d-flex align-items-start">
                            <div class="flex-grow-1">
                                <div class="d-flex justify-content-between align-items-center px-4 mt-1">
    
                                <a class="btn btn-md btn-primary">{{ this.mobile }}</a>
                                <a @click="logout()" class="btn btn-sm btn-danger">خروج</a>
                            </div>
                                <h4 class="mb-3 text-white" id="user-phone">{{ this.name }}</h4>
                            </div>
                        </div>
                    </div> <!-- .p-4 -->
                    <div class="chat-room-list"  data-simplebar="init"><div  class="simplebar-wrapper" style="margin: 0px;"><div  class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div><div class="simplebar-mask"><div class="simplebar-offset" style="left: 0px; bottom: 0px;"><div class="simplebar-content-wrapper"  style="height: auto; overflow: hidden;"><div  class="simplebar-content" style="padding: 0px;">
                        <!-- Start chat-message-list -->
                        <div class="d-flex justify-content-between align-items-center px-4 mt-1">
                            <h4  class="d-inline-block fs-30 text-muted text-uppercase">اعتبار</h4>
                            <h5 class="d-inline-block text-white fs-16"><span id="credit">{{ this.credit > 1000 ? 'نامحدود' :this.credit }}</span> <span>🍪</span></h5>
                            <a style="visibility: hidden;" class="btn btn-sm btn-primary">خرید کوکی🍪</a>
                        </div>  
                        <div class="d-flex justify-content-between align-items-center px-4 mt-1">
                            <h4 style="margin-top:10px"  class="d-inline-block fs-30 text-muted text-uppercase">انقضا</h4>
                            <h5 style="margin-top:10px"  class="d-inline-block text-white fs-16"><span id="credit">{{ this.engheza }}</span></h5>
                            <a @click="gotoPackages()" class="btn btn-sm btn-primary">خرید کوکی🍪</a>
                        </div>
                        <div class="d-flex justify-content-between">
                        <a @click="this.isModalReferral = true" style="margin-right: 10px;margin-left: 10px;" class="btn btn-md btn-info w-100" >دعوت دوستان</a>
                    </div>
                        <hr>  
                        <div class="d-flex justify-content-between align-items-center px-4 mt-1 mx-1">
                            <p class="text-white text-justify fs-13" style="text-align: justify;">
                                <strong> روبو </strong>, یک همراه همیشگی.
                                <br/>
                                <br/>
                            روبو بهترین دوست شماست که با شخصیت های مختلف و امکانات فراوان, به شما کمک میکند تا تمام نیاز هایتان را برطرف کنید. همچنان میتواند به زبان فارسی, انگلیسی و دیگر زبان ها با شما به صورت طبیعی و دوستانه صحبت کند.
                                <br/>
                                <br/>
                                روبو با استفاده از تکنولوژی, شبکه‌های عصبی و اطلاعات بروز اینترنت به پرسش‌های شما پاسخ داده و در موضوعات گوناگون شما را همراهی کند.
    
    
    </p>
                        </div> 
                        <hr class="no-margin">
                        
    
                        <!-- <hr>
                        <div class="mx-2 my-1">
                            <button class="btn btn-sm btn-outline-primary w-100 my-1" id="">Babbage</button>
                            <button class="btn btn-sm btn-outline-primary w-100 my-1" id="">Babbage</button>
                            <button class="btn btn-sm btn-outline-primary w-100 my-1" id="">Babbage</button>
                        </div> -->
                        <div class="text-center version">
                            <small class="text-muted">نسخه 0.0.3</small>
                        </div>
    
                        <!-- End chat-message-list -->
                    </div></div></div></div><div class="simplebar-placeholder" style="width: auto; height: 387px;"></div></div><div class="simplebar-track simplebar-horizontal" style="visibility: hidden;"><div class="simplebar-scrollbar" style="width: 0px; display: none;"></div></div><div class="simplebar-track simplebar-vertical" style="visibility: visible;"><div class="simplebar-scrollbar" style="height: 241px; display: block; transform: translate3d(0px, 65px, 0px);"></div></div></div>
                </div>
                <!-- Start chats content -->
            </div>
            <!-- End chats tab-pane -->
        </div>
        <!-- end tab content -->
    </div>
    <!-- end chat-leftsidebar -->
    
    <!-- Start User chat -->
    <div :class="isModalKharid == true || isModalNewUser == true || isModalReferral == true || isModalQuestion == true || isModalCategory == true || isModalVisible == true? 'custom' : ''" class="mx-1200 user-chat w-100 overflow-hidden border-l">
        <div class="chat-content d-lg-flex">
            <!-- start chat conversation section -->
            <div class="mx-1200 w-100 overflow-hidden position-relative">
                <!-- conversation user -->
                <div id="users-chat" class="position-relative">
                    <div class="py-3 user-chat-topbar">
                        <div class="row align-items-center">
                            <div class="col-sm-4 col-10">
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1 overflow-hidden">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 chat-user-img online user-own-img align-self-center me-3 ms-0">
                                                <img :src="iconofchat" class="rounded-circle avatar-sm" alt="">
                                                <span class="user-status"></span>
                                            </div>
                                            <div class="flex-grow-1 overflow-hidden">
                                                
                                                <h6 class="text-truncate mb-0 fs-15">
                                                    <a href="#" class="user-profile-show text-white">{{ nameofchat }}</a>
                                                </h6>
                                                <a v-if="this.history.length == 0 && this.chats.length == 0" @click="gotoCharacters()" class="btn btn-sm btn-primary" style="margin-top: 5px;">تغییر شخصیت ها</a>
                                                <a v-else @click="deleteConversation()" class="btn btn-sm btn-danger" style="margin-top: 5px;">حذف گفتگو</a>
                                            </div>
                                            <button v-if="this.isMobile" @click="$router.back()" class="p-button p-component tu-button btn-tertiary backBtn_U6DGe" style="position: absolute;left:15px" type="button">
                <i class="fa-solid fa-arrow-left" style="font-size:20px;color:rgb(209, 208, 208)"></i>
             </button>
             <div @click="isModalVersion = true" style="position: absolute;left:50px;display:flex;text-align: center;border-radius: 30px;padding:5px;margin-top:5px;margin-bottom:5px;height:2.5em;background: rgb(97,83,204);background: linear-gradient(90deg, rgb(106, 94, 202) 20%, #fd7691 100%);">
              <h3 style="margin-right:5px;margin-left: 5px;margin-top:4px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:15px"  class="pageTitle_36g65">تغییر {{ aiVersion }}</h3>
            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        
                    </div>
                    <!-- end chat user head -->
                    <!-- start chat conversation -->
                    <div class="chat-conversation p-3 p-lg-4 safty-margin" id="chat-conversation" data-simplebar="init" style="height: calc(100vh - 94px);"><div class="simplebar-wrapper" style="margin: -24px;"><div class="simplebar-height-auto-observer-wrapper"><div class="simplebar-height-auto-observer"></div></div><div class="simplebar-mask"><div class="simplebar-offset" style="left: 0px; bottom: 0px;"><div class="simplebar-content-wrapper" id="scroller"  style="height: 100%;  overflow: hidden scroll;"><div class="simplebar-content"  style="padding: 24px;">
                        <ul v-if="this.history.length > 0"  class="list-unstyled chat-conversation-list start-chat" id="conversation-area">
                            <!-- conversation created here -->
                        <li v-for="(item,index) in history" :key="item.id" v-bind:class="{'right': item.role === 'assistant' }" class="chat-list left id chat-list-1">
                            <div v-if="item.role == 'assistant'" class="right conversation-list"><div class="user-chat-content">
                                <div class="ctext-wrap">
                                    <div :id="'text'+ index" style="color: white" class="user-text">
                                        <span style="position:absolute;bottom:5px;right:10px" class="text-success check-message-icon"><i class="fa-solid fa-check"></i></span>
                                        <p style="margin-right: 10px;" class="rtl-dir mb-0 ctext-content text-white p-chat">
                                              <img v-if="this.character == 'roboimage' && item.role == 'assistant'" :src="'https://api3.roboo.ir/content/ImageGeneration/'+item.chat" style="max-width: 100%;max-height: 100%;" @click="this.imageSource='https://api3.roboo.ir/content/ImageGeneration/'+item.chat;this.showImage = true" :class="item.id != this.history.length ? 'fa-solid fa-check-double':'fa-solid fa-check'"/>
                                            </p></div><div class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0">
                                                <img :src="iconofchat" class="rounded-circle avatar-sm" alt="">
                                                <span class="user-status"></span></div></div><div class="conversation-name">
                                <button :id="'delete'+item.id" data-toggle="tooltip" data-placement="top" title="حذف" @click="deletes(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-trash" ></i>
                                </button> 
                                <button :id="'like'+item.id" data-toggle="tooltip" data-placement="top" title="لایک" @click="like(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-thumbs-up" ></i>
                                </button>  
                                <button :id="'dislike'+item.id" data-toggle="tooltip" data-placement="top" title="دیس لایک" @click="dislike(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-thumbs-down" ></i>
                                </button>  
                                <button data-toggle="tooltip" data-placement="top" title="کپی" v-clipboard:copy="item.chat" @click="copy(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i :id="'copy'+item.id" class="fa-solid fa-clipboard" ></i>
                                </button>  
                            </div></div></div>
                            <div v-if="item.role == 'user'" class="conversation-list"><div class="user-chat-content"><div class="ctext-wrap">
                            <div class="user-text" style="background-color: #6355cc; !important">
                                <span style="position:absolute;bottom:5px;right:10px" class="text-success check-message-icon"><i style="color: #06D6A0" :class="item.id != this.history.length ? 'fa-solid fa-check-double':'fa-solid fa-check'"></i></span>
                                <p style="margin-right: 10px;" class="rtl-dir mb-0 ctext-content text-white ltr-dir p-chat">{{item.chat}}</p>
                            </div></div></div></div>
                        </li>
                            
                            
                            <li class="line-break"><span>پایان گفتگو های قبلی</span></li>
                            </ul>
                            <ul  class="list-unstyled chat-conversation-list" id="conversation-area2">
                            <!-- conversation created here -->
                            <li data-v-96f3dc52="" class="right chat-list left id chat-list-1">
                                <div data-v-96f3dc52="" class="right conversation-list">
                                    <div data-v-96f3dc52="" class="user-chat-content">
                                        <div data-v-96f3dc52="" class="ctext-wrap">
                                            <div v-if="this.character != 'moshaver'" data-v-96f3dc52="" class="user-text">
                                                <p data-v-96f3dc52="" class="rtl-dir mb-0 ctext-content text-white p-chat">
                                                    سلام {{this.name}}! من روبو هستم.<br>
                                                     خیلی خوشحالم که شما اینجا هستید.<br>
                                                     من اینجام تا به تمام سوالات شما پاسخ بدم و باهم اوقات خوبی را سپری کنیم.<br>
                                                      برای شروع، چه موضوعی رو دوست دارید در موردش صحبت کنیم؟
                                                </p>
                                            </div>
                                            <div v-if="this.character == 'moshaver'" data-v-96f3dc52="" class="user-text">
                                                <p data-v-96f3dc52="" class="rtl-dir mb-0 ctext-content text-white p-chat">
                                                    سلام {{this.name}}! من روبو مشاور هستم, خیلی خوشحالم که امروز با شما در این جلسه مشاوره هستیم.<br> از اینکه به من اعتماد کردید و با من درباره مسائلی که برایتان مهم هستند صحبت خواهیم کرد، سپاسگزارم.
                                                </p>  <p data-v-96f3dc52="" class="rtl-dir mb-0 ctext-content text-white p-chat">
    من به عنوان یک روان‌شناس، هدفم کمک به شما در بهبود کیفیت زندگیتان است.<br> در این جلسات، با هم به دنبال پیدا کردن راه‌حل‌هایی برای مسائلی که شما با آن‌ها مواجه هستید، خواهیم بود.
    </p>
    <p data-v-96f3dc52="" class="rtl-dir mb-0 ctext-content text-white p-chat">
    اگر هرگونه سوال، نگرانی یا مشکلی در ذهن شما وجود دارد، لطفاً به من بگویید.<br> همه چیزی که در جلسات با من مطرح می‌کنید، به طور کامل محرمانه خواهد ماند و همیشه پشتیبان شما خواهم بود.
    </p><p data-v-96f3dc52="" class="rtl-dir mb-0 ctext-content text-white p-chat">
    پس در ادامه، منتظر شنیدن دغدغه‌های شما هستم.<br> هر موضوعی که به نظرتان مهم است را مطرح کنید و با هم بهترین راه حل را برای آن پیدا کنیم.
                                                </p>
                                            </div>
                                            <div data-v-96f3dc52="" class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0">
                                                <img data-v-96f3dc52="" :src="iconofchat" class="rounded-circle avatar-sm" alt="">
                                                <span data-v-96f3dc52="" class="user-status"></span></div></div>
                                               </div></div></li>
                        <li v-for="item in chats" :key="item.id" v-bind:class="{'right': item.role === 'assistant' }" class="chat-list left id chat-list-1">
                            <div v-if="item.role == 'assistant'" class="right conversation-list"><div class="user-chat-content"><div class="ctext-wrap"><div :id="'text'+ item.id" style="color: white" class="user-text"><p class="rtl-dir mb-0 ctext-content text-white p-chat">
                                <img v-if="this.character == 'roboimage' && item.role == 'assistant'" :src="'https://api3.roboo.ir/content/ImageGeneration/'+item.chat" style="max-width: 100%;max-height: 100%;" @click="this.imageSource='https://api3.roboo.ir/content/ImageGeneration/'+item.chat;this.showImage = true" :class="item.id != this.history.length ? 'fa-solid fa-check-double':'fa-solid fa-check'"/>
                                </p></div><div class="flex-shrink-0 chat-user-img online user-own-img align-self-center ms-3 ms-0"><img :src="iconofchat" class="rounded-circle avatar-sm" alt=""><span class="user-status"></span></div></div><div class="conversation-name"><span class="text-success check-message-icon"><i class="fa-solid fa-check"></i></span>
                                <button :id="'like'+item.id" data-toggle="tooltip" data-placement="top" title="لایک" @click="like(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-thumbs-up" ></i>
                                </button>  
                                <button :id="'dislike'+item.id" data-toggle="tooltip" data-placement="top" title="دیس لایک" @click="dislike(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-thumbs-down" ></i>
                                </button>  
                                <button data-toggle="tooltip" data-placement="top" title="کپی" v-clipboard:copy="item.chat" @click="copy(item.id)" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                                <i :id="'copy'+item.id" class="fa-solid fa-clipboard" ></i>
                                </button>  
                            </div>
                            <button v-if="this.showContinue == true && this.chats[this.chats.length-1].id == item.id" style="margin-top:3px" @click="sendcontinue()" class="btn btn-light btn-sm chat-send waves-effect waves-light">
                                               ادامه <i :id="'copy'+item.id" class="fa-solid fa-caret-down" ></i>
                                </button>  
                        </div></div>
                            <div v-if="item.role == 'user'" class="conversation-list"><div class="user-chat-content"><div class="ctext-wrap">
                            <div class="user-text" style="background-color: #6355cc !important;"> <span style="position:absolute;bottom:5px;right:10px" class="text-success check-message-icon"><i style="color: #06D6A0" :class="item.id != this.chats.length ? 'fa-solid fa-check-double':'fa-solid fa-check'"></i></span><p style="margin-right: 10px;" class="rtl-dir mb-0 ctext-content text-white ltr-dir p-chat">{{item.chat}}</p></div></div></div></div>
                        </li>
                            
                            
                        
                            </ul>
                    </div></div></div></div><div class="simplebar-placeholder" style="width: auto; height: 357px;"></div></div><div class="simplebar-track simplebar-horizontal" style="visibility: hidden;"><div class="simplebar-scrollbar" style="width: 0px; display: none;"></div></div><div class="simplebar-track simplebar-vertical" style="visibility: visible;"><div class="simplebar-scrollbar" style="height: 320px; display: block; transform: translate3d(0px, 18px, 0px);"></div></div></div>
                    <!-- end chat conversation end -->
                </div>
                <!-- conversation group -->
    
                <!-- start chat input section -->
                <div class="position-relative">
                    <div class="chat-reply-section px-4 py-1 pb-0 border-top">
                        <div class="row g-0 align-items-center">
                            <div class="col-auto reply-section-btn">
                                <button class="btn btn-link btn-md reply-section-close-btn">
                                    <i class="fa fa-times align-middle"></i>
                                </button>
                            </div>
                            <div class="col reply-section-text">
                                text here...
                            </div>
                            <div class="col-auto reply-section-icon">
                                <i class="bx bxs-share align-middle"></i>
                            </div>
                        </div>
                    </div>
                    <div class="chat-input-section ramin border-top">
                        <div id="chatinput-form">
                            <div class="row g-0 align-items-end">
                                <div class="col-auto mar-left-5">
                                    <div class="chat-input-links ms-2 gap-md-1">
                                        <div class="links-list-item">
                                            <button id="voicebutton" v-if="this.chatbox == ''" @touchstart="start()"  @touchend="end()" class="btn btn-primary btn-lg chat-send waves-effect waves-light">
                                                <i id="voiceicon" style="margin-top:5px" class="fa-solid fa-microphone" ></i>
                                            </button>
                                            <button v-else @click="checkConvThenPost()" class="btn btn-primary btn-lg chat-send waves-effect waves-light">
                                                <i  class="fa-solid fa-paper-plane" style="margin-top:5px"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="position-relative">
                                        <div class="chat-input-feedback d-none">
                                            لطفا یک پیام بنویسید
                                        </div>
                                        <input class="d-none" type="hidden" id="_token" value="KOMMLg0FNGPyR4ya4nf2bf2ukqoAQxc2INZNv65MDgosIYCkn1xXpuPhczx05XGZ">
                                        <input class="d-none" type="hidden" id="reply-id-input" value="">
                                        <textarea   autoresize autocomplete="off" type="text" class="form-control form-control-lg bg-light border-0 chat-input" v-on:keydown.enter="handleEnter" autofocus="" id="textarea-input" :value="chatbox"
@input="e => chatbox = e.target.value" placeholder="متن خود را بنویسید ..." style="text-align: start;unicode-bidi: plaintext;height: 43px; overflow-y: auto; min-height: 43px; resize: none;"></textarea>
                                        <div class="chat-input-typing" v-if="istyping" id="is-typing">
                                            <span v-if="this.character != 'roboimage'" class="typing-user d-flex text-white">روبو
                                                درحال
                                                پاسخ
                                                <span class="typing ms-2">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </span>
                                            </span>
                                            <span v-else class="typing-user d-flex text-white">روبو
                                                درحال
                                                خلق ایده شما
                                                <span class="typing ms-2">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-auto mar-left-5">
                                    <div class="chat-input-links ms-2 gap-md-1">
                                        <div class="links-list-item" >
                                            <button data-toggle="tooltip" data-placement="top" title="سوال های آماده" @click="this.isModalQuestion = true" class="btn btn-info btn-lg chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-lightbulb" ></i>
                                            </button>
                                            
                                        </div>
                                        <!-- <div class="links-list-item" style="padding-right: 5px;">
                                        <button  data-toggle="tooltip" data-placement="top" title="پاک کردن چت فعلی" @click="clearChats()" class="btn btn-light btn-lg chat-send waves-effect waves-light">
                                                <i class="fa-solid fa-eraser" ></i>
                                            </button>
                                            </div>-->
                                    </div> 
                                </div>
                            </div>
                        </div>
    
                    </div>
                    
                </div>
                <!-- end chat input section -->
            </div>
            <!-- end chat conversation section -->
        </div>
        <!-- end user chat content -->
    </div>
    <!-- End User chat -->
    <div v-if="isModalQuestion" class="login-box">
        <div class="basket"><div  class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2">دسته بندی ها</h5>
        <div style="margin-top:5px" class="d-flex justify-content-between">
           <button @click="categorys(1)" type="submit" class="text-white btn btn-primary w-100"  >موزیک</button>
        
           <button @click="categorys(2)" type="submit" class="text-white btn btn-primary w-100" style="margin-right:10px" >سلامتی</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">
           <button @click="categorys(3)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">مارکتینگ</button>
        
           <button @click="categorys(4)" type="submit" class="text-white btn btn-primary w-100" style="margin-right:10px;margin-top:5px" >آشپزی</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">
           <button @click="categorys(5)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">Chat GPT</button>
        
           <button @click="categorys(6)" type="submit" class="text-white btn btn-primary w-100" style="margin-right:10px;margin-top:5px" >محتوا</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">
           <button @click="categorys(7)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">کسب و کار</button>
        
           <button @click="categorys(8)" type="submit" class="text-white btn btn-primary w-100" style="margin-right:10px;margin-top:5px" >آموزش</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">    
           <button @click="categorys(9)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">برنامه نویسی</button>
        </div>
        <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">    
           <button @click="this.isModalQuestion = false" type="submit" class="text-white btn btn-danger w-100">بستن</button>
        </div>
    
            
    </div><!----><!----></div>
    </div>
    <div v-if="isModalCategory" class="login-box" >
        <div class="basket"><div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2">{{ this.category }}</h5>
            <div class="d-flex flex-column" v-for="(item,index) in texts" :key="index">
                <a @click="textToChatBox(item)" type="submit" style="margin-bottom: 7px; text-align:start" class="text-white btn btn-info btn-sm w-100">{{ item }}</a>
    </div>
    
            
    </div> <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">    
           <button @click="this.isModalCategory = false" type="submit" class="text-white btn btn-danger w-100">بستن</button>
        </div><!----><!----></div>
    </div>
    <div v-if="isModalNewUser" class="login-box">
        <div class="basket"><div  class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2">تبریک!</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 pb-4 text">به شما 15 کوکی 🍪 برای 7 روز داده شد.</p>
                <button @click="closeModalNewUser()" type="submit" class="text-white btn btn-primary pt-3 pb-3 ps-4 pe-4" style="margin-bottom:10px;right:33%;position: relative">مرسی</button>
    </div><!----><!----></div>
    </div>
    
    <div v-if="isModalVisible" class="login-box">
        <div class="basket"><div :class="this.kharid == 0? 'purchaseSuccess':'purchaseFail'" class=" mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2">{{this.kharid == 0 ? 'خرید انجام شد!':'خرید انجام نشد!'}}</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 pb-4 text">کاربر گرامی <br>{{this.kharidText}}</p>
                <button @click="closeModal()" type="submit" class="text-white btn btn-primary pt-3 pb-3 ps-4 pe-4" style="margin-bottom:10px;right:35%;position: relative">بستن</button>
    </div><!----><!----></div>
    </div>
    <div v-if="this.showImage == true" class="modal">
    
      <!-- The Close Button -->
      <span class="close" @click="this.showImage = false">&times;</span>
    
      <!-- Modal Content (The Image) -->
      <img :src="this.imageSource" class="modal-content" id="img01">
      <a v-if="!this.isApplication" style="margin: auto;
      display: block;
      width: 90%;
      max-width: 512px;margin-top:5px" :href="this.imageSource" download rel="noopener noreferrer" target="_blank" type="submit" class="text-white btn btn-info btn-md">دانلود</a>
    <a v-else style="margin: auto;
      display: block;
      width: 90%;
      max-width: 512px;margin-top:5px" :name="this.imageSource" onclick="Android.Download(this.name)" class="text-white btn btn-info btn-md">دانلود</a>
    
      <!-- Modal Caption (Image Text) 1-->
      <div id="caption"></div>
    </div>
    <div v-if="isModalKharid" class="login-box scrolling" style="overflow-y: auto;">
        <div class="basket"><div class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <i @click="isModalKharid = false" class="fa-solid fa-x" style="margin-top:5px;font-size: 15px;color:white;margin-top:-10px;"></i>
            <h5 class="mb-4 fw-bold pt-2" style="font-size:17px;font-weight: bold;margin-top:-15px;">روبو شکمش خالیه! ☹️</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 15px;
      text-align: center;margin-bottom:-15px" class="font-12 pb-4 text" >ای وای، کوکیات🍪 تموم شده ولی ما هواتو داریم.
</p>
<hr>
<p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">با خریدن بیشتر کوکی‌🍪، گفتگوهای نامحدودی را با برترین هوش مصنوعی به دست آورید. از مکالمات بی‌وقفه لذت ببرید و به امکانات ویژه دسترسی داشته باشید.</p>
                <button @click="gotoPackages()" type="submit" class="text-white btn w-100" style="font-weight:bold;background-color: #E23E57;"><i class="fa-solid fa-shopping-basket" style="margin-left:5px;color:white"></i>همین حالا خرید کنید!</button>
                <hr>
                <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">روبو را به اشتراک بگذارید! یک دوست را به روبو معرفی کنید و برای هر معرفی موفقیت‌آمیز، ۵۰ کوکی🍪 هم شما و دوستتان دریافت می کنید.</p>
                <button @click="isModalKharid = false;showReferral()" style="font-weight:bold;margin-bottom:5px;" type="submit" class="text-white btn btn-info w-100"><i class="fa-solid fa-user-friends" style="margin-left:5px;color:white"></i>دعوت دوستان</button>
                <div v-if="isApplication" style="margin-bottom:5px;">   
                <hr>
                <p style="white-space: pre-line;
      padding: 0;
      color: #fff;font-size: 14px;line-height: 25px;
      text-align: right;margin-bottom:-5px" class="font-12 pb-4 text">همچنین میتونید با دیدن تبلیغی کوتاه، 3 کوکی🍪 رایگان دریافت کنید.</p>
                <button @click="showAd()" type="submit" class="text-white btn btn-primary w-100" ><i class="fa-solid fa-play" style="margin-left:5px;color:white"></i>تماشای ویدیو</button>
                </div>
            </div><!----><!----></div>
    </div>
    <div v-if="isModalVersion" class="login-box">
        <div class="basket"><div  class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2">مدل های هوش مصنوعی</h5>
        <div style="margin-top:5px" class="d-flex justify-content-between">    
           <button @click="selectVersion(0)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">GPT 3.5: مناسب برای کار های روزانه و کلی</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">    
           <button @click="selectVersion(1)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">GPT 4: درک بهتر،کیفیت پاسخگویی بالاتر،اطلاعات بروزتر از GPT 3.5</button>
        </div>
        <div style="margin-top:5px" class="d-flex justify-content-between">    
           <button @click="selectVersion(2)" type="submit" class="text-white btn btn-primary w-100" style="margin-top:5px">Perplexity AI: همانند جستجوی گوگل، اطلاعات کاملا بروز و همچنین امکان درج لینک، مناسب برای مقاله و قیمت و اطلاعات مفید و ...</button>
        </div>
        <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">    
           <button @click="this.isModalVersion = false" type="submit" class="text-white btn btn-danger w-100">بستن</button>
        </div>
    
            
    </div><!----><!----></div>
    </div>
    
    
    </div>
    </template>
    
    <script>
    /* eslint-disable */
    import router from '@/router';
    import axios from 'axios';
    import { notify } from "@kyvg/vue3-notification";
    import markdown from 'markdown-it';
    import markdownItLatex from 'markdown-it-texmath'
    import katex from 'katex'
    var md = new markdown();
                md.use(markdownItLatex,{engine: katex,
                             delimiters: 'brackets',
                             katexOptions: { output: "mathml"}});  
    var Emitter = require('tiny-emitter');
    var emitter = new Emitter();
    export default {
      head: {
        },
      name: 'HelloWorld',
      props: {
        msg: String
      },
      data() {
                    return {
                        isModalVersion:false,
                        aiCodeVersion: 0,
                        aiVersion: 'GPT 3.5',
                        conversationId:'',
                        iconofchat: 'https://roboo.ir/wp-content/uploads/2023/05/botNormal.png',
                        nameofchat:'روبو',
                        name:'',
                        mobile:'',
                        kharidText:'خرید شما با موفقیت انجام شد.',
                        credit:0,
                        chatbox: '',
                        kharid: 0,
                        adShowing: false,
                        category: 'موزیک',
                        isModalNewUser:false,
                        isModalReferral:false,
                        isModalQuestion:false,
                        invites:[],
                        mediaRecorder:null,
                        chunks: [],
                        imageSource:"",
                        Referral:'',
                        timerRecorder:null,
                        engheza:'1402-01-01',
                        character: 'chat',
                        texts: [],
                        lastMessage:'',
                        showImage: false,
                        isModalCategory: false,
                        isModalVisible:false,
                        isModalKharid: false,
                        startRecordTime:null,
                        streamRecord:null,
                        showContinue:false,
                        isApplication: navigator.userAgent.match(/ir.roboo.pwa/i)?true:false,
                        isMobile: navigator.userAgent.match(/Android/i)
             || navigator.userAgent.match(/webOS/i)
             || navigator.userAgent.match(/iPhone/i)
             || navigator.userAgent.match(/iPad/i)
             || navigator.userAgent.match(/iPod/i)
             || navigator.userAgent.match(/BlackBerry/i)
             || navigator.userAgent.match(/Windows Phone/i)?true:false,
                        istyping: false,
                        isMicrophoneAccess:false,
                        chats: [
                           
                        ],
                        history:[]
                    }
                },
      methods: {
        selectVersion(id)
        {
            this.isModalVersion = false;
            this.aiCodeVersion = id;
            if(id == 0)
            this.aiVersion = "GPT 3.5";
            else if(id == 1)
            this.aiVersion = "GPT 4";
            else if(id == 2)
            this.aiVersion = "Perplexity";
        },
        async start()
        {
            // eslint-disable-next-line
            if(this.isApplication)
            {
               Android.CheckMicrophone();
            }
            if(this.userInfo.credit <= 0)
            {
                this.isModalKharid = true;
                return;
            }
            var that = this;
            this.startRecordTime = new Date();
            var icon = document.getElementById("voiceicon");
            if(icon.classList.contains("fa-ellipsis"))
            {
                return;
            }
            var button = document.getElementById("voicebutton");
            button.classList.add("rec-effect-4");
            icon.classList.remove('fa-microphone');
            icon.classList.add('fa-stop');
            this.timerRecorder = setTimeout(()=>{
            if(that.mediaRecorder.state == 'recording')
            that.end()
            },30000)
           
            this.chunks = [];


            navigator.mediaDevices.getUserMedia({
    audio: true
  }).then(stream => {
    that.streamRecord = stream;
    console.log("Started Streaming");
    that.mediaRecorder = new MediaRecorder(stream,
    {
        audioBitsPerSecond: 16000,
    })
        that.mediaRecorder.ondataavailable = (e) => {
            that.chunks.push(e.data);
            
        };
        that.mediaRecorder.onstop = (e)=>
        {
            const blob = new Blob(this.chunks, { type: "audio/ogg; codecs=opus" });
            var reader = new window.FileReader();
reader.readAsDataURL(blob); 
reader.onloadend = function() {
   var base64 = reader.result;
   base64 = base64.split(',')[1];
   let json = {
                fileBase64:base64
            }
            axios.post("https://api3.roboo.ir/api/chat/senddata",json).then((response) =>{
                if(response.data.status == 0)
                {
                    if(response.data.message == "PYM JBZ")
                    {
                        notify({
      title: "خطا",
      text: "ویس خالی است.",
      type: "error"
    });
                    }
                    else
                    that.chatbox = response.data.message;
                    setTimeout(() => {
            var resizingTextareas2 = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas2.forEach(function(resizingTextareas) {
     if(resizingTextareas.scrollHeight < 150 && resizingTextareas.scrollHeight > 57)
      {
        resizingTextareas.style.height = 'auto';
        resizingTextareas.style.height = resizingTextareas.scrollHeight+'px';
        resizingTextareas.scrollTop = resizingTextareas.scrollHeight;
      window.scrollTo(window.scrollLeft,(resizingTextareas.scrollTop+resizingTextareas.scrollHeight));
      }
      if(resizingTextareas.scrollHeight == 58)
      {
        resizingTextareas.style.height = 'auto';
        resizingTextareas.style.height = '43px';
        resizingTextareas.scrollTop = '43';
      window.scrollTo(window.scrollLeft,(resizingTextareas.scrollTop+resizingTextareas.scrollHeight));
      }
    });
            },5);
                }
                else
                {
                    notify({
      title: "خطا",
      text: response.data.message,
      type: "error"
    });
                }
                icon.classList.remove('fa-ellipsis');
                icon.classList.add('fa-microphone');
            }).catch(()=>{
                icon.classList.remove('fa-ellipsis');
                icon.classList.add('fa-microphone');
                notify({
      title: "خطا",
      text: "هنگام ارسال درخواست مشکلی به وجود امده.\nلطفا دوباره تلاش کنید.",
      type: "error"
    });
            });

            
}

            
            that.chunks = [];
           
        }
        that.mediaRecorder.start()

})
    .catch(err => log(err.name + ": " + err.message));
    console.log("Hereeee4");

        },
        end()
        {
            if(this.userInfo.credit <= 0)
            {
                return;
            }
            var button = document.getElementById("voicebutton");
            button.classList.remove("rec-effect-4");
            var icon = document.getElementById("voiceicon");
            icon.classList.remove('fa-stop');
            var timeDiff = Math.abs(this.startRecordTime.getTime() - (new Date()).getTime());
            console.log(timeDiff);
            if(timeDiff < 1000)
            {
                notify({
      title: "روبو",
      text: "دکمه را نگه دارید.",
      type: "info"
    });
                icon.classList.add('fa-microphone');
               
                return;
            }

            var that = this;
            var button = document.getElementById("voicebutton");
            button.classList.remove("rec-effect-4");
            var icon = document.getElementById("voiceicon");
            icon.classList.remove('fa-stop');
            icon.classList.add('fa-ellipsis');
            setTimeout(()=>{
            that.mediaRecorder.stop()
            that.streamRecord.getTracks().forEach(track => {
  track.stop()
  track.enabled = false
})

            },500);
            clearInterval(this.timerRecorder);
        },
        showReferral()
        {
            this.$emit("showReferral");
        },
        showCredit()
        {
            this.$emit("showCredit");
        },
        handleEnter(event) {
            if(this.isMobile)
            return;
            if ((event.shiftKey &&event.key === 'Enter')) {
        // Allow the default behavior of creating a new line on Android devices
        return;
      }
     
          event.preventDefault();
          if(this.character == 'roboimage')
          this.generateImage();
          else
          this.postToServer();
        },
        showAd()
        {
            notify({
      title: "روبو",
      text: "در حال اماده سازی ویدیو. لطفا منتظر بمانید!",
      type: "info"
    });
    this.isModalKharid=false;
    this.userInfo.credit = this.userInfo.credit +3;
    this.$emit("setCredit")
    this.credit = this.credit + 3;
    try {
        Android.ShowAdAdivery('8a4d6b52-0e81-4470-8755-c1e6e08806fa',"3");
        //Android.ShowAd('64b58b3c4bf57453cab34119',"3");
    }
    catch {
        try{
          Android.ShowAd('64b58b3c4bf57453cab34119',"3");
        }
        catch{
          Android.ShowAd('64b58b3c4bf57453cab34119');
        }
    }
    this.chatbox = this.lastMessage;
    this.lastMessage = "";
        },
        clearChats()
        {
    
            if(this.istyping)
        {
           notify({
      title: "روبو",
      text: "در حال صحبت هستم لطفا پس از اتمام پاک کنید",
      type: "info"
    });
    return;
        }
            
            //this.getuserData();
    
    
     notify({
      title: "روبو",
      text: "پاکش کردم و داخل گفتگو های قبلیت ریختمش😏",
      type: "info"
    });
        
        },
        copy(id)
        {
            let element = document.getElementById('copy'+id);
            element.classList.remove('fa-clipboard');
            element.classList.add('fa-check');
    
            setTimeout(() => {
                element.classList.add('fa-clipboard');
            element.classList.remove('fa-check');
            },1500)
            notify({
      title: "روبو",
      text: "برات کپیش کردم 🥰",
      type: "info"
    });
        },
        showCopy()
        {
            notify({title: "کپی",text: "کد شما کپی شد",type: "success"});
        },
        categorys(id)
        {
            
            if(id == 1)
            {
                this.category = "موزیک";
                this.texts=[];
                this.texts.push("می خواهم یک موزیک ویدیو بسازم اما نمی دانم از چه مفهومی استفاده کنم. منو راهنمایی کن");
                this.texts.push("یک پشروی آکورد بلوز 12 نواری در کلید E بنویسید");
                this.texts.push("متن آهنگی با عنوان [عنوان آهنگ] را بنویس");
                this.texts.push("یک شعر یا آهنگ برای <مخاطب هدف> ایجاد کنید که <موضوع انتخلبی شما> را توضیح دهد");
                this.texts.push("پیشرفت آکورد زیر را تغییر دهید تا بیشتر شبیه <بر اساس برخی دستورات, مانند آهنگساز یا سبک> باشد");
                this.texts.push("متن شعر مرغ سحر ناله سر کن شجریان رو بنویس");
                this.texts.push("من می خواهم یک فایل midi بنویسم. میشه کد python رو بزارید");
                this.texts.push("یک آهنگ در مقیاس پنتاتونیک و 4/4 زمان برای <هنرمند مورد نظر خود> بنویس");
                this.texts.push("یک مشاعره بین حافظ و مولانا انجام بده");
                this.texts.push("پیشرفت های آکورد را برای یک آهنگ راک کانتری, با شعر,کر و بریج بنویسید");
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 2)
            {
                this.category = "سلامتی";
                this.texts=[];
                this.texts.push("چند راه برای پرورش ذهنیت رشد چیست؟");
                this.texts.push("4 وعده غذایی مغذی را در نظر بگیرید که می توانید در عرض نیم ساعت یا کمتر تهیه کنید");
                this.texts.push("چند تمرین ذهن آگاهی برای کاهش اضطراب چیست؟");
                this.texts.push("من به کمک نیاز دارم تا در کار با انگیزه بمانم. می توانی به من چند راهکار بدی؟");
                this.texts.push("چند تا فعالیت خود مراقبتی را برای کاهش استرس پیشنهاد بده");
                this.texts.push("یک برنامه ورزشی 30 روزه ایجاد کنید که به من کمک میکند هر هفته 2 کیلو وزن کم کنم");
                this.texts.push("8 تا ماده غذایی که ارزان باشه و به طرز شگفت انگیزی مغذی باشه رو بهم بگو");
                this.texts.push("برای <دستیابی به یک کار یا هدف خاص> به انگیزه نیاز دارم. میشه بهم انگیزه بدی");
                this.texts.push("شش حرکت کششی موثر در یوگا را برای کمردرد و گردن توضیح دهید");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 3)
            {
                this.category = "مارکتینگ";
                this.texts=[];
                this.texts.push("چگونه میتوانم Back link های با کیفیت برای بالا بردن SEO [نام وب سایت] به دست بیاورم؟");
                this.texts.push("یک طرح کمپین [رسانه های اجتماعی] برای راه اندازی [محصول شما] با هدف [مخاطبان هدف شما] بساز");
                this.texts.push("یک اسکریپت یک دقیقه ای برای تبلیغ درمورد (محصول یا خدمت یا شرکت) بساز");
                this.texts.push("یک پست برای انتشار در توئیتر بساز که نسل زد را هدف قرار دهد و توضیح دهد که چگونه محصول ما [نام محصول] می تواند به آنها کمک کند");
                this.texts.push("قهرستی از 5 ایده ویدیوی YouTube برای [محصول یا شرکت شما] تهیه کن");
                this.texts.push("یک خبرنامه هفتگی [موضوع خبرنامه] را بساز");
                this.texts.push("یک توضیح محصول برای [محصول یا خدمت یا شرکت] من بنویس");
                this.texts.push("یک پست اینستاگرام بساز که مزایای محصول من رو (نام محصول) پیشنهاد بده");
                this.texts.push("5 روش خلاقانه برای استفاده از حلقه های اینستاگرام برای شما ایجاد کنید");
                this.texts.push("چطور میتوانم فالور های اینستاگرام افزایش بدم");
                this.texts.push("روش های مقرون به صرفه برای تبلیغ (شرکت) خود با/بدون استفاده از (شبکه های اجتماعی) پیشنهاد بده");
                this.texts.push("برای افرادی که در وبینار {موضوع وبینار} من شرکت کرده اند ایمیل های تکمیلی بنویسید");
                this.texts.push("یک ایمیل تبریک شخصی برای یک مشتری VIP بنویس");
                this.texts.push("یه ایده هایی برای پست های ولاگ درمورد موضوع (انتخابی) نیاز دارم");
                this.texts.push("چجوری میتوانم یک استراتژی برای استوری های روزانه در اینستاگرام داشته باشم؟");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 4)
            {
                this.category = "آشپزی";
                this.texts=[];
                this.texts.push("یه منو باحال بهاری بگو؟");
                this.texts.push("من گیاهخوار هستم. یه ایده باحال برای شام بهم بده");
                this.texts.push("برای کسی که یه روز سخت داشته یه غذای خوب پیشنهاد بده");
                this.texts.push("من گوجه, کاهو و کلم بروکلی دارم. چه چیزی می توانم با آنها برای یک ناهار وگان آماده کنم؟");
                this.texts.push("برای یک هغته شام دو بزرگسال برنامه ریزی کن که چه غذاهایی بپزم");
                this.texts.push("سریع و آسان ترین راه برای تهیه ماکارونی با سس سفید و قارچ چیست؟");
                this.texts.push("من فقط پیاز, گوجه فرنگی و اسفناج دارم. 3 وعده غذایی را به من بگو که با این مواد درست کنم؟");
                this.texts.push("یک برنامه غذایی برای دو روز تهیه کنید و لیست خرید آن را به من بدهید");
                this.texts.push("برای نوروز ایرانی, دستور پخت غذای جذاب با ماهی بهم پیشنهاد کن");
                this.texts.push("طرز تهیه خورشت قیمه رو بگو");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 5)
            {
                this.category = "Chat GPT";
                this.texts=[];
                this.texts.push("آیا Chat GPT امن است؟");
                this.texts.push("Chat GPT چیست؟");
                this.texts.push("آیا Chat GPT می تواند یک مقاله بنویسد؟");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 6)
            {
                this.category = "محتوا";
                this.texts=[];
                this.texts.push("وبلاگ در مورد [موضوع دلخواه شما] بنویسید");
                this.texts.push("یک داستان علمی تخیلی در 200 کلمه بنویس که شخصیت اول اسمش علی باشه و میخواهد دنیا را نجات دهد");
                this.texts.push("یک مطالعه موردی با جزئیات <موضوع انتخابی> بنویسید");
                this.texts.push("یک درس درمورد منابع انرژی تجدید پذیر برای دانش آموزان دبیرستانی طراحی کن");
                this.texts.push("یک راهنمای جامع برای [موضوع] بنویسید");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 7)
            {
                this.category = "کسب و کار";
                this.texts=[];
                this.texts.push("چه عواملی را باید در هنگام نقل قول برای یک معامله برند در نظر بگیرم؟");
                this.texts.push("به عنوان یک صاحب کسب و کار کوچک, درمورد شبکه سازی و ایجاد مشارکت راهنماییم کن");
                this.texts.push("درباره <صنعت> و روندها, چالش ها و فرصت های آن, از جمله داده ها و آمار های مربوطه راهنماییم کن");
                this.texts.push("من باید یک ارائه برای یک سرمایه گذار بالقوه در مورد <موضوع ارائه> آماده کنم. میشه راهنماییم کنید که چی بزارم؟");
                this.texts.push("یک بررسی دقیق از <نرم افزار یا ابزار خاص> برای <تشریح کسب و کار خود> انجام بده");
                
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 8)
            {
                this.category = "آموزش";
                this.texts=[];
                this.texts.push("من یه معلم هستم. یه فهرست از 10 ویژگی منحصر به فرد را برای درج در رزومه بعنوان یک معلم ریاضی بنویس");
                this.texts.push("بهترین روش آموزش کودکان چیست؟");
                this.texts.push("فهرستی از مراحل مشخص و قابل اجرا که یک دانش آموز باید انجام دهد تا بتواند عملکرد خود را در (موضوع/وظیفه) بهبود بخشد تهیه کن");
                this.texts.push("یه سوال چهار گزینه ای طرح کن که صورت سوال درباره گرم شدن کره زمین باشه");
                this.texts.push("کودکان در یادگیری حروف صدا دار چه مشکلاتی دارند؟");
                this.texts.push("یک مقاله در مورد تبعیض اجتماعی بنویس که نمره 20 بگیرم");
                this.texts.push("برای آموزش یک زبان جدید چه مراحلی باید طی شه؟");
                this.texts.push("پیشنهاد طراحی یه پوستر بده که دانش آموزان, مقررات کلاس درس و همچنین مجازات را متوجه بشوند");
                this.texts.push("فهرستی از 5 استراتژی آموزشی ایجاد کنید که می تواند برای درگیر کردن و به چالش کشیدن دانش آموزان در سطوح مختلف توانایی در یک درس در مورد [مفهوم در حال آموزش] استفاده شود.");
                this.texts.push("2 راهکار برای معلم ها که بتوانند بر یادگیری و پیشرفت دانش آموزان نظارت کنند پیشنهاد بده");
                
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
            else if(id == 9)
            {
                this.category = "برنامه نویسی";
                this.texts=[];
                this.texts.push("من می خواهم یک هدر چسبنده در وب سایت خود پیاده سازی کنم. آیا می توانید مثالی از نحوه انجام این کار با استفاده از CSS و جاوا اسکریپت ارائه دهید ؟");
                this.texts.push("نام جدول هارا فرض کنید و یک کد SQL ایجاد کنید تا توییت های ایلان ماسک در سال 2019 را داشته باشد");
                this.texts.push("یک docstring برای تابغ زیر <تابع شما> بنویسید");
                this.texts.push("اشکال کد زیر را پیدا کن: <کد>");
                this.texts.push("من درحال ساخت یک وب سایت برای یک تجارت کوچک [شرح کسب و کار]. من به ایده هایی درمورد چگونگی ساختار وب سایت نیاز دارم");
                this.texts.push("این regex دقیقا چه کاری انجام میدهد ؟ <کد شما>");
                this.texts.push("من می خواهم رندر سمت سرور را برای برنامه React خود پیاده سازی کنم. آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Next.js ارائه دهید؟");
                this.texts.push("لطفا به نوشتن این کد برای جاوا اسکریپت <کد شما> ادامه دهید");
                this.texts.push("من باید یک نقطه پایانی  Rest API برای برنامه وب ایجاد کنم");
                this.texts.push("آیا میتوانید مثالی از نحوه انجام این کار با استفاده از Node.js ارائه دهید؟");
                this.texts.push("یه نکنه طراحی UX ارائه دهید تا بتوانم آن را در Linkedin به اشتراک بگذارم");
                this.texts.push("با استفاده از وردپرس فهرستی از 10 مهارت و تجربه مرتبط را برای یک برنامه شغلی توسعه دهنده وب ایجاد کنید");
                this.texts.push("یک معماری توسعه وب سایت با جاوا اسکریپت پیشنهاد بده");
    
                this.isModalQuestion = false;
                this.isModalCategory = true;
            }
        },
        changeToImage()
        {
            if(this.character == 'roboimage')
            {
            this.character = 'chat';
            this.nameofchat = 'روبو'
            }
            else
            {
            this.character = 'roboimage';
            this.nameofchat = 'روبو پیکاسو';
            }
            //this.getuserData();
             setTimeout(() => {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
        , 1000)
    
        },
        
        deletes(id)
        {
            let id2= id-1;
    
             axios.post("https://api3.roboo.ir/api/chat/Delete?Token="+localStorage.getItem("token")+"&Id="+id);
            this.history = this.history.filter(x => {
                return x.id != id;
            })
            this.history = this.history.filter(x => {
                return x.id != id2;
            })
            notify({
      title: "روبو",
      text: "حذف شد. کی؟ کجا؟ کدوم پیام؟ 😉 ",
      type: "info"
    });
        },
        like(id)
        {
            document.getElementById('like'+id).setAttribute("style", "background-color: #878a99;");
            let element =  document.getElementById('dislike'+id);
            if(element != null)
            element.remove();
            notify({
      title: "روبو",
      text: "خیلی خوشحالم مرسی بابت فیدبکت 😍 ",
      type: "info"
    });
        },
        dislike(id)
        {
            document.getElementById('dislike'+id).setAttribute("style", "background-color: #878a99;");
            let element =  document.getElementById('like'+id);
            if(element != null)
            element.remove();
            notify({
      title: "روبو",
      text: "مرسی بابت فیدبکت دفعه بعد بیشتر تلاش میکنم 😘",
      type: "info"
    });
        },
        checkChat(chat)
        {
            let char = new RegExp("[\u0600-\u06FF]");
            if(chat != "")
            {
            if (char.test(chat) === true) {
                return true;
            }
            else {
                return false;
            }
            }
        },
        closeModalNewUser()
        {
            this.isModalNewUser = false;
        },
        closeModal()
        {
            this.isModalVisible = false;
        },
        gotoCharacters(){
            router.push('characters');
        },
        gotoPackages(){
            router.push('packages');
        },
        showPoshtibani()
        {
          
        },
        logout()
        {
            localStorage.setItem('token',"");
            router.push('login');
        },
        textToChatBox(matn)
        {
            this.isModalCategory = false;
            this.chatbox = matn;
            setTimeout(() => {
            var resizingTextareas2 = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas2.forEach(function(resizingTextareas) {
     if(resizingTextareas.scrollHeight < 150 && resizingTextareas.scrollHeight > 57)
      {
        resizingTextareas.style.height = 'auto';
        resizingTextareas.style.height = resizingTextareas.scrollHeight+'px';
        resizingTextareas.scrollTop = resizingTextareas.scrollHeight;
      window.scrollTo(window.scrollLeft,(resizingTextareas.scrollTop+resizingTextareas.scrollHeight));
      }
      if(resizingTextareas.scrollHeight == 58)
      {
        resizingTextareas.style.height = 'auto';
        resizingTextareas.style.height = '43px';
        resizingTextareas.scrollTop = '43';
      window.scrollTo(window.scrollLeft,(resizingTextareas.scrollTop+resizingTextareas.scrollHeight));
      }
    });
            },5);
        },
    
    
    
    
    
    
    
    
    
    
    
        generateImage()
        {
    if(this.istyping == true)
            {
                notify({
      title: "روبو",
      text: "در حال ساخت هستم لطفا منتظر بمانید",
      type: "info"
    });
            return;
            }
            if(this.chatbox == "")
            {
                 notify({
      title: "روبو",
      text: "جواب هیچیو چجوری بدم؟ 😵",
      type: "info"
    });
            return;
            }
            this.chats.push({id : this.chats.length+1,chat:this.chatbox,role:"user"})
            this.istyping = true;
            this.lastMessage = this.chatbox;
            this.chatbox = "";
            var resizingTextareas = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas.forEach(function(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = '43px';
        textarea.scrollTop = '43';
      
    });
          
            setTimeout(() => {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
        , 5)
            let isFarsi = false;
            let char = new RegExp("[\u0600-\u06FF]");
            if(this.chats[this.chats.length - 1].chat != "")
            {
                if (char.test(this.chats[this.chats.length - 1].chat) === true) {
                    isFarsi = true;
                }
            }
            let json = {
                token : localStorage.getItem("token"),
                message: this.chats[this.chats.length-1].chat,
                farsi: isFarsi
            }
    
             axios.post("https://api3.roboo.ir/api/chat/GetImage",json).then(response => {
                
                if(response.data.status == 0)
             {
                this.istyping = false;
                this.chats.push({id : this.chats.length+1,chat:response.data.message,role:"assistant"})
                this.credit = this.credit -3;
                setTimeout(() => {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
        , 1000)
             }
             else if(response.data.status == 2)
             {
                this.istyping = false;
                    this.isModalKharid = true;
                    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
             }
             else
             {
                 this.istyping = false;
                //Error
                notify({
      title: "خطا",
      text: response.data.message,
      type: "error"
    });
    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
             }
                
             });
        },
    
        deleteConversation()
        {
            if(this.conversationId != "")
            {
                let json =
                {
                    Token: localStorage.getItem("token"),
                    ConversationId: this.conversationId
                }
                axios.post("https://api3.roboo.ir/api/chat/DeleteConversation",json).then(response => {
                if(response.data.status == 0)
                {
                    router.back()
                    notify({
                title: "روبو",
                text: response.data.message,
                type: "success"
                });
                }
                else
                {
                    notify({
                title: "خطا",
                text: response.data.message,
                type: "error"
                });
                }
                });
            }
        },
        checkConvThenPost()
        {
            if(this.conversationId != "")
            this.postToServer();
            else
            {
                let jsonconv = {
                token : localStorage.getItem("token"),
                character: this.character,
                title: this.chatbox
            }
    
             axios.post("https://api3.roboo.ir/api/chat/CreateConversation",jsonconv).then(response => {
                
                if(response.data.status == 0)
                {
                    this.conversationId = response.data.message;
                    localStorage.setItem("conversationId",response.data.message);
                    this.postToServer();
                }
                else if(response.data.status == 2)
                {
                    this.isModalKharid = true;
                    this.userInfo.credit = 0;
                    this.$emit("setCredit")

                    return;
                }
                else
                {
                //Error
                notify({
                title: "خطا",
                text: response.data.message,
                type: "error"
                });
            }
            });
            }
        },
        sendcontinue()
        {
            this.chatbox="ادامه";
            this.postToServer();
        },
        postToServer()
        {
            this.showContinue = false;
            if(this.istyping == true)
            {
                notify({
      title: "روبو",
      text: "در حال صحبت هستم لطفا منتظر بمانید ❤️",
      type: "info"
    });
            return;
            }
            if(this.chatbox == "")
            {
                 notify({
      title: "روبو",
      text: "جواب هیچیو چجوری بدم؟ 😵",
      type: "info"
    });
            return;
            }

        
            
            this.chats.push({id : this.chats.length+1,chat:this.chatbox,role:"user"})
            this.istyping = true;
            this.lastMessage = this.chatbox;
            this.chatbox = "";
            var resizingTextareas = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas.forEach(function(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = '43px';
        textarea.scrollTop = '43';
      
    });
          
            setTimeout(() => {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
        , 5)
            let isFarsi = false;
            let char = new RegExp("[\u0600-\u06FF]");
            if(this.chats[this.chats.length - 1].chat != "")
            {
                if (char.test(this.chats[this.chats.length - 1].chat) === true) {
                    isFarsi = true;
                }
            }
            let json = {
                token : localStorage.getItem("token"),
                messages: this.chats,
                character: this.character,
                farsi: isFarsi,
                conversationId: this.conversationId,
                aiVersion: this.aiCodeVersion
            }
            this.responseServer = false;
            const controller = new AbortController()
            const signal = controller.signal
            var newreq = setTimeout(() => {
                if(this.responseServer == false)
                {
                    controller.abort();
                    fetch('https://api4.roboo.ir/api/chat/getanswerc' ,{method: 'POST', //This could be any http method
      headers: {
        'Content-Type': 'application/json',
      },body:JSON.stringify(json)})
            .then(response => {
                this.responseServer = true;
                clearTimeout(newreq);
                if(this.userInfo.credit>0)
                this.userInfo.credit--;
                this.credit --;
                this.$emit("setCredit")

                var text = "";
                const reader = response.body.getReader();
                const decoder = new TextDecoder();              
                
    var textbox = null;
    var element = document.querySelector('#scroller');
    
    this.chats.push({id : this.chats.length+1,chat:"",role:"assistant"})
                const read = () => {
                    
                    reader.read().then(({ done, value }) => {
                        if (done) {
                            this.istyping = false;
                            return;
                        }
    
                        const data = decoder.decode(value, { stream: true });
                        text += data;
                        var parsed = null;
                        try {  
                         parsed = JSON.parse(data);
                        } catch {  
                            var t = null;
                            t;
    }
                         if(parsed != null && parsed.status == 1)
                {
                    this.istyping = false;
                //Error
                notify({
      title: "خطا",
      text: parsed.message,
      type: "error"
    });
    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
                }
                else if(parsed!= null && parsed.status == 2)
                {
                    this.istyping = false;
                    this.isModalKharid = true;
                    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
                }
                var res = md.render(text);
                if(textbox != null)
                textbox.innerHTML = res;
                else
                {
                textbox = document.getElementById('text'+this.chats.length)
                }
    
    // Get a list of all the child elements inside the parent element
    const childElements = textbox.querySelectorAll('*');
    
    // Iterate over the list of child elements using a forEach loop
    childElements.forEach(function(element) {
      // Perform an action on each element, such as adding a CSS class
        element.style.textAlign = 'start';
      element.style.unicodeBidi = 'plaintext';
      element.style.marginBottom = '0px';
    });
        element.scrollTop = element.scrollHeight;
           
            
    
                        read();
                    });
                this.chats[this.chats.length - 1].chat = text;
                };
    
                read();
                
    
            });
                }
            }
        , 15000)
        
            fetch('https://api3.roboo.ir/api/chat/getanswerc' ,{method: 'POST', signal: signal, //This could be any http method
      headers: {
        'Content-Type': 'application/json',
      },body:JSON.stringify(json)})
            .then(response => {
                this.responseServer = true;
                if(this.userInfo.credit>0)
                this.userInfo.credit--;
                this.$emit("setCredit1")

                this.credit --;
                var text = "";
                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                  
    var textbox = null;
    var element = document.querySelector('#scroller');
    
    this.chats.push({id : this.chats.length+1,chat:"",role:"assistant"})
    setTimeout(() => {
            textbox = document.getElementById('text'+this.chats.length)
    
            }
        , 100)
                const read = () => {
                    
                    reader.read().then(({ done, value }) => {
                        if (done) {
                            this.istyping = false;
                            this.$emit("setCredit");
                            setTimeout(()=>{
                            this.credit +=1;
                            this.credit -=1;
                            
                        },1000)
                        setTimeout(()=>{
                            this.credit +=1;
                            this.credit -=1;
                        },3000)
                            return;
                        }
    
                        const data = decoder.decode(value, { stream: true });
                        console.log(data)
                        if(data.includes('برای ادامه دادن دکمه ادامه را بزنید.'))
                        {
                            text += "\r\nبرای ادامه دادن دکمه ادامه را بزنید.";
                            this.istyping = false;
                            this.showContinue = true;
                        }
                        else
                        text += data;
                        var parsed = null;
                        try {  
                         parsed = JSON.parse(data);
                        } catch {  
                            var t = null;
                            t;
    }
                         if(parsed != null && parsed.status == 1)
                {
                    this.istyping = false;
                //Error
                notify({
      title: "خطا",
      text: parsed.message,
      type: "error"
    });
    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
                }
                else if(parsed!= null && parsed.status == 2)
                {
                    this.istyping = false;
                    this.isModalKharid = true;
                    this.chats.pop();
    this.chats.pop();
    this.credit = 0;
    return;
                }
                console.log(text);
                var res = md.render(text);
                if(textbox != null)
                textbox.innerHTML = res;
                else
                {
                textbox = document.getElementById('text'+this.chats.length)
                }
    
    // Get a list of all the child elements inside the parent element
    const childElements = textbox.querySelectorAll('*');
    
    // Iterate over the list of child elements using a forEach loop
    childElements.forEach(function(element) {
      // Perform an action on each element, such as adding a CSS class
        element.style.textAlign = 'start';
      element.style.unicodeBidi = 'plaintext';
      element.style.marginBottom = '0px';
    });
        element.scrollTop = element.scrollHeight;
           
           
            
    
                        read();
                    });
                this.chats[this.chats.length - 1].chat = text;
                };
                read();
                
    
            });
            
           
            },
            getchatFromConversation()
        {
            this.chats=[];
        this.history=[];
        var conv = this.conversationId;
        if(conv == "")
        conv="undefined"
             axios.get("https://api3.roboo.ir/api/chat/getChatFromConversation?token="+localStorage.getItem("token")+"&conversationid="+conv)
        .then(response=>{
            console.log(response.data);
            if(response.data.status == 0)
            {
                if(response.data.character != null && response.data.character != "")
                {
                    this.setCharacter(response.data.character)
                }
                else
                this.setCharacter('chat')
                for (let index = 0; index < response.data.messages.length; index++) {
                    const element = response.data.messages[index];
                    
                    this.history.push(element)
                    if(element.role == 'assistant' && this.character != 'roboimage')
                    {
                    setTimeout(() => {
           
            var res = md.render(element.chat);
            document.getElementById('text'+index).innerHTML = res;
            setTimeout(() => {
            const parent = document.querySelector('#text'+index);

            const childElements = parent.querySelectorAll('*');

            childElements.forEach(function(element2) {
            element2.style.textAlign = 'start';
            element2.style.unicodeBidi = 'plaintext';
            element2.style.marginBottom = '0px';
                    });
                },1);
            },10);
        }
                }
                setTimeout(() => {
        var element = document.querySelector('#scroller');
    element.scrollTop = element.scrollHeight;
        }
    , 100)
    setTimeout(() => {
         if(element != null)
        {
        var element = document.querySelector('#scroller');
    element.scrollTop = element.scrollHeight;
        }
        }
    , 2000)
    
            }
            else if(response.data.status == 1)
            {

            }
            else
            {
                //NotSuccess
                router.push("login");
            }
        }).catch(function(error) {
            console.log(error);
            console.log(error.code);
  if (!error.response) {
    router.push("/game");
    // network error (server is down or no internet)
  } else {
    // http status code
    console.log(error.response.status)
    // data from server while error
    console.log(error.response.data)
  }});
        },
            getuserData()
            {
                this.chats=[];
            this.history=[];
                 axios.get("https://api3.roboo.ir/api/Users/GetUserData?token="+localStorage.getItem("token")+"&character="+this.character)
            .then(response=>{
                if(response.data.status == 0)
                {
                    this.mobile = response.data.mobile;
                    this.credit = response.data.credit;
                    this.name = response.data.name;
                    this.engheza = response.data.packageEndDate;
                    this.invites = response.data.referrals;
                    this.Referral = response.data.referral;
                    for (let index = 0; index < response.data.chats.length; index++) {
                        const element = response.data.chats[index];
                        
                        this.history.push(element)
                        if(element.role == 'assistant' && this.character != 'roboimage')
                        {
                        setTimeout(() => {
                
                var res = md.render(element.chat);
                document.getElementById('text'+index).innerHTML = res;
                setTimeout(() => {
                const parent = document.querySelector('#text'+index);
    
                const childElements = parent.querySelectorAll('*');
    
                childElements.forEach(function(element2) {
                element2.style.textAlign = 'start';
                element2.style.unicodeBidi = 'plaintext';
                element2.style.marginBottom = '0px';
                        });
                    },1);
                },10);
            }
                    }
                    setTimeout(() => {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
        , 100)
        setTimeout(() => {
             if(element != null)
            {
            var element = document.querySelector('#scroller');
        element.scrollTop = element.scrollHeight;
            }
            }
        , 2000)
        
                }
                else
                {
                    //NotSuccess
                    router.push("login");
                }
            }).catch(function(error) {
                console.log(error);
                console.log(error.code);
      if (!error.response) {
        router.push("/game");
        // network error (server is down or no internet)
      } else {
        // http status code
        console.log(error.response.status)
        // data from server while error
        console.log(error.response.data)
      }});
            },
        setCharacter(id)
        {
            this.character = id;
            if(this.character == 'moshaver')
            {
            this.nameofchat = 'روبو مشاور';
            this.iconofchat = require('@/assets/img/characters/botMoshaver.png');
            }
            else if(this.character == 'mechanic')
            {
                this.nameofchat = 'روبو مکانیک';
                this.iconofchat = require('@/assets/img/characters/botMechanic.png');
            }
            else if(this.character == 'code')
            {
                this.nameofchat = 'روبو برنامه نویس';
                this.iconofchat = require('@/assets/img/characters/botCode.png');
            }
            else if(this.character == 'teacher')
            {
                this.nameofchat = 'روبو معام';
                this.iconofchat = require('@/assets/img/characters/botTeacher.png');
            }
            else if(this.character == 'translate')
            {
                this.nameofchat = 'روبو مترجم';
                this.iconofchat = require('@/assets/img/characters/botTranslator.png');
            }
            else
            {
                this.nameofchat = 'روبو';
                this.iconofchat = require('@/assets/img/characters/botNormal.png');
            }
        }
       
      },
      mounted() {
        if(this.$route.query.id != null)
        {
            this.setCharacter(this.$route.query.id);
        }
        else
        this.setCharacter("chat");
        if(localStorage.getItem("userName") != null)
        this.name = localStorage.getItem("userName");
        var suggestion = localStorage.getItem("selectedSuggestion");
        if(suggestion != null && suggestion != "")
        {
            this.chatbox = suggestion;
            localStorage.setItem("selectedSuggestion","");
        }
        var that = this;
        
        this.conversationId = localStorage.getItem("conversationId");
             if(this.conversationId == null)
             this.conversationId = "";
        // if(this.$route.query.Authority != null)
        //   {
        //     if(this.$route.query.Status != "OK")
        //     {
        //         var order = this.$route.query.Authority;
        //         order = order.replace("00000000000000000000000000","");
        //         this.isModalVisible = true;
        //         this.kharid = 1;
        //         this.kharidText='لطفا با پشتیبانی تماس بگیرید\n کد تراکنش: \n'+order.replace("A","");
        //     }
    
        window.addEventListener("offline", function() {
      router.push('/game');
    });
        
        var token = localStorage.getItem("token");
        if(token != null && token != "")
        {
            this.getchatFromConversation();
        }
        else
        {
            router.push("login");
        }
    
        var resizingTextareas = [].slice.call(document.querySelectorAll('textarea[autoresize]'));
    
    resizingTextareas.forEach(function(textarea) {
      textarea.addEventListener('input', autoresize, false);
      
    });
    function autoresize() {
        //findType(this)
      if(this.scrollHeight < 150 && this.scrollHeight > 57)
      {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight+'px';
      this.scrollTop = this.scrollHeight;
      window.scrollTo(window.scrollLeft,(this.scrollTop+this.scrollHeight));
      }
      if(this.scrollHeight == 58)
      {
        this.style.height = 'auto';
      this.style.height = '43px';
      this.scrollTop = '43';
      window.scrollTo(window.scrollLeft,(this.scrollTop+this.scrollHeight));
      }
    }
      },
    }
    
    </script>
    
    <style scoped>
    @import '../assets/bootstrap-rtl.min.css';
    @import '../assets/app-rtl.min.css';
    @import '../assets/tekStyle.css';

    @media (max-height: 650px) {
  .scrolling {
    height: 100%;
  }
}
    .custom {
  filter: blur(5px);
}
    .rec-effect-4 {
	transition: box-shadow 0.33s ease-in-out;
	animation: rec-effect-4 1s infinite;
}
    @keyframes rec-effect-4 {
	0% {
		box-shadow: 0 0 0 0 #333,
								0 0 0 0 #6153cc,
								0 0 0 0 #6153cc;	
	}
	11% {
		box-shadow: 0 0 0 7px #333,
								0 0 0 10px #a499f7,
								0 0 0 0 #a499f7;
	}
	77% {
		box-shadow: 0 0 0 0 #333,
								0 0 0 5px #8274ee,
								0 0 0 13px #8274ee;
	}
}
    .something {
        color: var(--v-primary-base);
        background-color: #565656;
      }
    @font-face {
            font-family: IRANSansWeb;
            src: url('../assets/IRANSansWeb.woff2') format("woff2");
            font-weight: normal;
            font-style: normal;
        }
        @font-face {
            font-family: IRANSansWeb;
            src: url('../assets/IRANSansWebBold.woff2') format("woff2");
            font-weight: bold;
            font-style: normal;
        }
        * {
      font-family: IRANSansWeb;
    }
    a {
        font-family: IRANSansWeb;
        font-weight: bold;
    }
    .rtl-dir
    {
        text-align: start;
        unicode-bidi: plaintext;
    }
    .user-text * {
        
        text-align: start !important;
        unicode-bidi: plaintext !important;
    }
    .ltr-dir
    {
        text-align: left;
    }
    .p-chat
    {
        white-space: pre-line;
    }
    
    textarea[autoresize] {
      display: block;
      overflow: hidden;
      resize: none;
      text-align: start;
        unicode-bidi: plaintext;
    }
    .login-box {
      top: 50%;
            left: 50%;
            position: fixed;
      width: 90vw;
      padding: 10px;
      transform: translate(-50%, -50%);
    z-index: 10000;
      background-color:rgb(24, 24, 24);
      box-sizing: border-box;
      box-shadow: 0 15px 25px rgba(0,0,0,.6);
      border-radius: 10px;
    
    }
    .purchaseSuccess {
        border: 1px solid #9184f7
    }
    
    .purchaseSuccess .title {
        color: #9184f7
    }
    
    .purchaseSuccess .text {
        line-height: 22px;
    }
    
    .purchaseFail .text {
        line-height: 22px;
    }
    
    .purchaseAlert .text {
        line-height: 22px;
    }
    
    .purchaseSuccess 
    .fa-thumbs-up {
        color: #0abf81;
        border: 1px solid #0abf81;
        top: -15px;
        left: 20px;
    }
    
    .purchaseFail {
        border: 1px solid #ff0048
    }
    
    .purchaseFail .title {
        color: #ff0048;
    }
    
    .fa-light-emergency-on {
        color: #ff0048;
        border: 1px solid #ff0048;
        top: -15px;
        left: 20px;
    }
    
    .purchaseAlert {
        border: 1px solid #ff6c00
    }
    
    .purchaseAlert .title {
        color: #ff6c00;
    }
    
    .fa-diamond-exclamation {
        color: #ff6c00;
        border: 1px solid #ff6c00;
        top: -15px;
        left: 20px;
    }
    
    .line-break {
      position: relative;
      margin-top: 10px;
    }
    
    .line-break::before {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      border-top: 1px solid #ccc;
      position: absolute;
      top: 50%;
    }
    
    .line-break span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 3px 10px;
    }
    .ramin{
        padding: 1.5rem 0.5rem 1.5rem 0.5rem !important;
    }
    
    
    /* The Modal (background) */
    .modal {
      display: block; /* Hidden by default */
      position: fixed; /* Stay in place */
      z-index: 100000; /* Sit on top */
      padding-top: 100px; /* Location of the box */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 100%; /* Full height */
      overflow: hidden; /* Enable scroll if needed */
      background-color: rgb(0,0,0); /* Fallback color */
      background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
    }
    
    /* Modal Content (image) */
    .modal-content {
      margin: auto;
      display: block;
      width: 90%;
      max-width: 512px;
    }
    
    /* Caption of Modal Image */
    #caption {
      margin: auto;
      display: block;
      width: 80%;
      max-width: 700px;
      text-align: center;
      color: #ccc;
      padding: 10px 0;
      height: 150px;
    }
    
    /* Add Animation */
    .modal-content, #caption {  
      -webkit-animation-name: zoom;
      -webkit-animation-duration: 0.6s;
      animation-name: zoom;
      animation-duration: 0.6s;
    }
    
    @-webkit-keyframes zoom {
      from {-webkit-transform:scale(0)} 
      to {-webkit-transform:scale(1)}
    }
    
    @keyframes zoom {
      from {transform:scale(0)} 
      to {transform:scale(1)}
    }
    
    /* The Close Button */
    .close {
      position: absolute;
      top: 15px;
      right: 35px;
      color: #f1f1f1;
      font-size: 40px;
      font-weight: bold;
      transition: 0.3s;
    }
    
    .close:hover,
    .close:focus {
      color: #bbb;
      text-decoration: none;
      cursor: pointer;
    }
    
    /* 100% Image Width on Smaller Screens */
    @media only screen and (max-width: 700px){
      .modal-content {
        width: 90%;
      }
    }
    </style>